import MailGroupHeadersStore from './schema/MailGroupHeadersStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const MailListGroupHeaderDefaultStore: MailGroupHeadersStore = {
    groupHeaders: new ObservableMap<string, boolean>({}),
};

export const store = createStore<MailGroupHeadersStore>(
    'MailGroupHeader',
    MailListGroupHeaderDefaultStore
)();

export default function getStore() {
    return store;
}
